export default __webpack_public_path__ + "videos/resource.mp4";